import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar({ isAuthenticated, setIsAuthenticated }) {
  const [user, setUser] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setUser(isAuthenticated);
  }, [isAuthenticated]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
    window.dispatchEvent(new Event('auth-updated'));
    setMenuOpen(false);
  };

  return (
    <header className="market-header">
      <div className="market-topbar">
        <Link className="market-brand" to="/" onClick={() => setMenuOpen(false)}>
          <span className="brand-mark">M</span>
          <span>
            <strong>Marketplace</strong>
            <small>buy, sell, discover</small>
          </span>
        </Link>

        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`market-nav ${menuOpen ? 'is-open' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>Shop</Link>
          {user ? (
            <>
              <Link to="/list-product" onClick={() => setMenuOpen(false)}>Sell</Link>
              <Link to="/my-products" onClick={() => setMenuOpen(false)}>My Listings</Link>
              <Link to="/cart" onClick={() => setMenuOpen(false)}>Cart</Link>
              <Link to="/profile" onClick={() => setMenuOpen(false)}>Account</Link>
              <button type="button" className="nav-button" onClick={handleLogout}>Log Out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMenuOpen(false)}>Log In</Link>
              <Link className="nav-cta" to="/register" onClick={() => setMenuOpen(false)}>Create Account</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
